// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6604) return "static/chunks/6604-331c06ec65bfadd7.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1303":"1b7925cc","8219":"79340e88"}[chunkId] || chunkId) + "." + {"1303":"48629d576401be9e","1322":"25547c28a3b26090","5021":"6215b01fc3626d4a","8219":"f6a044577e4f923c"}[chunkId] + ".js";
};